import { Intake } from "@/api/types/intake"
import { Lesson } from "@/api/types/lessons"
import { parseISO, differenceInMinutes } from "date-fns"
import { MINUTES_BEFORE_EVENT_TO_CHECK_IN } from "toptaal-shared"

export function shouldRenderPresenceButtons({
  date,
  startTime,
  presenceRegistered,
}: {
  date: string | null
  startTime: Lesson["startTime"] | null
  presenceRegistered: boolean
}): boolean {
  if (presenceRegistered || date == null || startTime == null) return false

  const now = new Date()
  const eventDateTime = parseISO(`${date}T${startTime}`)
  const minutesDiff = differenceInMinutes(eventDateTime, now)

  return minutesDiff <= MINUTES_BEFORE_EVENT_TO_CHECK_IN
}

export function isIntakeInPast(
  date: string | null,
  startTime: Lesson["startTime"] | null,
): boolean {
  if (date == null || startTime == null) return false

  const now = new Date()
  const eventDateTime = parseISO(`${date}T${startTime}`)

  return now > eventDateTime
}

export function canEditIntakeResults({
  status,
  presenceRegistered,
}: Pick<Intake, "status" | "presenceRegistered">): boolean {
  if (status === "historical" || status === "completed") return false

  return !presenceRegistered
}
